/**
 * Copia texto para a área de transferência com fallback resiliente para execCommand caso
 * a API navigator.clipboard falhe (ex: documento sem foco, WebView móvel).
 *
 * @param {string} text - Texto a ser copiado
 * @returns {Promise<boolean>} Retorna true se copiado com sucesso
 */
export const copyToClipboard = async (text) => {
  if (!text) return false;

  // 1. Tenta API moderna navigator.clipboard
  if (typeof navigator !== "undefined" && navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.warn("navigator.clipboard.writeText falhou, tentando fallback:", err);
    }
  }

  // 2. Fallback clássico via document.execCommand('copy')
  if (typeof document !== "undefined") {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "-9999px";
      textArea.style.left = "-9999px";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      return Boolean(successful);
    } catch (fallbackErr) {
      console.warn("Fallback execCommand copy falhou:", fallbackErr);
      return false;
    }
  }

  return false;
};
